// JSON-LD Schema generators for SEO

export const PersonSchema = {
  "@context": "https://schema.org",
  "@type": "Person",
  "name": "Edgardo Andrade",
  "alternateName": "EMABRAW",
  "url": "https://www.emabraw.com",
  "image": "https://www.emabraw.com/edgardo-portrait.jpg",
  "sameAs": [
    "https://www.instagram.com/emabraw",
    "https://cuanto.app/emabraw.pa"
  ],
  "jobTitle": "Fotógrafo Documental",
  "worksFor": {
    "@type": "Organization",
    "name": "Independiente"
  },
  "description": "Fotógrafo documental panameño. Desde 2017, documento la vida cotidiana de mi país, su espontaneidad y ritmo.",
  "knowsAbout": ["Fotografía Documental", "Street Photography", "Fotografía Artística", "Fotografía de Panamá"],
  "nationality": {
    "@type": "Country",
    "name": "Panamá"
  },
  "award": [
    "World Photographic Cup - Team Panama, Singapore 2023",
    "PSA Gold Medal 2023",
    "Winner Nuevos Talentos Latinoamericanos 2021"
  ]
};

export const OrganizationSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  "name": "EMABRAW",
  "alternateName": "Edgardo Andrade Fotografía",
  "url": "https://www.emabraw.com",
  "logo": "https://www.emabraw.com/logo.png",
  "image": "https://www.emabraw.com/og-image.jpg",
  "description": "Portafolio de fotografía documental de Edgardo Andrade. Documentando la vida cotidiana de Panamá.",
  "address": {
    "@type": "PostalAddress",
    "addressLocality": "Panamá",
    "addressCountry": "PA"
  },
  "contactPoint": {
    "@type": "ContactPoint",
    "telephone": "+507-6754-1097",
    "contactType": "customer service",
    "availableLanguage": ["Spanish", "English"]
  },
  "sameAs": [
    "https://www.instagram.com/emabraw",
    "https://cuanto.app/emabraw.pa"
  ]
};

export const WebsiteSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  "name": "EMABRAW",
  "alternateName": "Edgardo Andrade Fotografía Documental",
  "url": "https://www.emabraw.com",
  "description": "Portafolio de fotografía documental de Edgardo Andrade",
  "inLanguage": "es-PA",
  "author": {
    "@type": "Person",
    "name": "Edgardo Andrade"
  },
  "potentialAction": {
    "@type": "SearchAction",
    "target": "https://www.emabraw.com/proyectos?q={search_term_string}",
    "query-input": "required name=search_term_string"
  }
};

export const ImageGallerySchema = (projects) => ({
  "@context": "https://schema.org",
  "@type": "ImageGallery",
  "name": "Proyectos Fotográficos - EMABRAW",
  "description": "Galería de proyectos de fotografía documental y artística",
  "creator": {
    "@type": "Person",
    "name": "Edgardo Andrade"
  },
  "image": projects.map(project => ({
    "@type": "ImageObject",
    "name": project.title,
    "description": project.description,
    "dateCreated": project.date,
    "contentUrl": project.photos[0]?.url,
    "author": {
      "@type": "Person",
      "name": "Edgardo Andrade"
    }
  }))
});

export const CreativeWorkSchema = (project) => ({
  "@context": "https://schema.org",
  "@type": "CreativeWork",
  "name": project.title,
  "description": project.description,
  "dateCreated": project.date,
  "author": {
    "@type": "Person",
    "name": "Edgardo Andrade"
  },
  "genre": project.classification,
  "image": project.photos.map(photo => ({
    "@type": "ImageObject",
    "contentUrl": photo.url,
    "name": photo.name
  })),
  "creator": {
    "@type": "Person",
    "name": "Edgardo Andrade",
    "url": "https://www.emabraw.com"
  }
});

export const BreadcrumbSchema = (items) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  "itemListElement": items.map((item, index) => ({
    "@type": "ListItem",
    "position": index + 1,
    "name": item.name,
    "item": item.url
  }))
});
